var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("h5", [_vm._v("Заявки " + _vm._s(_vm.tabName))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _vm.$route.params.orderId
          ? _c("h6", [
              _vm._v("\n        Заявка\n        "),
              _c("strong", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.mixinGoToRouter("editOrder", {
                          id: _vm.$route.params.orderId,
                        })
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$route.params.orderId))]
                ),
              ]),
              _vm._v("\n        создана\n      "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "tabs tabs-simple" }, [
          _vm.enabledTabs
            ? _c(
                "ul",
                { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
                [
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link active",
                        attrs: {
                          "data-toggle": "tab",
                          href: "#manual",
                          role: "tab",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getOrdersByType(_vm.ordersTypes.manual)
                          },
                        },
                      },
                      [_vm._v("Ручные")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        attrs: {
                          "data-toggle": "tab",
                          href: "#delivery",
                          role: "tab",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getOrdersByType(_vm.ordersTypes.delivery)
                          },
                        },
                      },
                      [_vm._v("Доставочные")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        attrs: {
                          "data-toggle": "tab",
                          href: "#post",
                          role: "tab",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getOrdersByType(_vm.ordersTypes.post)
                          },
                        },
                      },
                      [_vm._v("Почтовые")]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _c(
              "div",
              {
                staticClass: "tab-pane active",
                attrs: { id: "manual", role: "tabpanel" },
              },
              [
                _c("div", { staticClass: "flex ago_text_block" }, [
                  _c(
                    "div",
                    { staticClass: "ago_text" },
                    [
                      _vm.$OrdersList[0]
                        ? _c("span", { staticClass: "m-r-10" }, [
                            _vm._v("Всего: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$OrdersList[0].length)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v("\n                Обновлено:\n                "),
                      _c("time-ago", {
                        attrs: {
                          refresh: "",
                          datetime: _vm.refreshTime[_vm.ordersTypes.manual],
                          locale: "ru",
                          long: "",
                          tooltip: "true",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "vue-ladda",
                        {
                          attrs: {
                            "button-class": "btn btn-sm btn-info",
                            "data-style": "zoom-in",
                            loading: _vm.refreshing[_vm.ordersTypes.manual],
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getOrdersByType(
                                _vm.ordersTypes.manual,
                                true
                              )
                            },
                          },
                        },
                        [_vm._v("Обновить\n                ")]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("pulse-loader", {
                      staticClass: "text-center",
                      attrs: {
                        loading: _vm.loading[0],
                        color: _vm.loadingColor,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$OrdersList[0] && !_vm.loading[0]
                  ? _c("ordersList", {
                      ref: "manualOrdersList",
                      attrs: {
                        orders: _vm.$OrdersList[0],
                        projects: _vm.projects,
                        cities: _vm.cities,
                        subStatuses: _vm.subStatuses,
                        displayType: "manager",
                        orderType: "manual",
                        fetchOrders: _vm.fetchOrders,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$OrdersList[0]
                  ? _c(
                      "div",
                      [
                        _c(
                          "vue-ladda",
                          {
                            attrs: {
                              "button-class": "btn btn-success",
                              "data-style": "zoom-in",
                              loading: _vm.allSendLoading,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.sendOrders()
                              },
                            },
                          },
                          [_vm._v("Отправить выбранные\n              ")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-pane",
                attrs: { id: "delivery", role: "tabpanel" },
              },
              [
                _c("div", { staticClass: "flex ago_text_block" }, [
                  _vm.newOrders[1]
                    ? _c("div", { staticClass: "ago_text" }, [
                        _vm._v("\n                Новых:\n                "),
                        _c("span", { staticClass: "badge badge-success" }, [
                          _vm._v(_vm._s(_vm.newOrders[1].new)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ago_text" },
                    [
                      _vm.newOrders[1]?.total
                        ? _c("span", { staticClass: "m-r-10" }, [
                            _vm._v("Всего: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.newOrders[1].total)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v("\n                Обновлено:\n                "),
                      _c("time-ago", {
                        attrs: {
                          refresh: "",
                          datetime: _vm.refreshTime[_vm.ordersTypes.delivery],
                          locale: "ru",
                          long: "",
                          tooltip: "true",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "vue-ladda",
                        {
                          attrs: {
                            "button-class": "btn btn-sm btn-info",
                            "data-style": "zoom-in",
                            loading: _vm.refreshing[_vm.ordersTypes.delivery],
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getOrdersByType(
                                _vm.ordersTypes.delivery,
                                true
                              )
                            },
                          },
                        },
                        [_vm._v("Обновить\n                ")]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("pulse-loader", {
                      staticClass: "text-center",
                      attrs: {
                        loading: _vm.loading[1],
                        color: _vm.loadingColor,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$OrdersList[1] && !_vm.loading[1]
                  ? _c("ordersList", {
                      attrs: {
                        orders: _vm.$OrdersList[1],
                        projects: _vm.projects,
                        cities: _vm.cities,
                        subStatuses: _vm.subStatuses,
                        displayType: "manager",
                        updateOrders: _vm.updateOrders,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 3,
                            "margin-pages": 2,
                            "click-handler": (page) =>
                              _vm.getOrdersByType(1, true, page),
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.paginator.current_page,
                            callback: function ($$v) {
                              _vm.$set(_vm.paginator, "current_page", $$v)
                            },
                            expression: "paginator.current_page",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-pane",
                attrs: { id: "post", role: "tabpanel" },
              },
              [
                _c("div", { staticClass: "flex ago_text_block" }, [
                  _vm.newOrders[2]
                    ? _c("div", { staticClass: "ago_text" }, [
                        _vm._v("\n                Новых:\n                "),
                        _c("span", { staticClass: "badge badge-success" }, [
                          _vm._v(_vm._s(_vm.newOrders[2])),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ago_text" },
                    [
                      _vm.$OrdersList[2]
                        ? _c("span", { staticClass: "m-r-10" }, [
                            _c("span"),
                            _vm._v("Всего:\n                  "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$OrdersList[2].length)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v("\n                Обновлено:\n                "),
                      _c("time-ago", {
                        attrs: {
                          refresh: "",
                          datetime: _vm.refreshTime[_vm.ordersTypes.post],
                          locale: "ru",
                          long: "",
                          tooltip: "true",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "vue-ladda",
                        {
                          attrs: {
                            "button-class": "btn btn-sm btn-info",
                            "data-style": "zoom-in",
                            loading: _vm.refreshing[_vm.ordersTypes.post],
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getOrdersByType(
                                _vm.ordersTypes.post,
                                true
                              )
                            },
                          },
                        },
                        [_vm._v("Обновить\n                ")]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("pulse-loader", {
                      staticClass: "text-center",
                      attrs: {
                        loading: _vm.loading[2],
                        color: _vm.loadingColor,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$OrdersList[2] && !_vm.loading[2]
                  ? _c("ordersList", {
                      attrs: {
                        orders: _vm.$OrdersList[2],
                        projects: _vm.projects,
                        cities: _vm.cities,
                        subStatuses: _vm.subStatuses,
                        displayType: "manager",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 10,
                            "margin-pages": 3,
                            "click-handler": (page) =>
                              _vm.getOrdersByType(2, true, page),
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.paginator.current_page,
                            callback: function ($$v) {
                              _vm.$set(_vm.paginator, "current_page", $$v)
                            },
                            expression: "paginator.current_page",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }